module.exports = __webpack_public_path__ + "assets/img/dragon-hit.b8b7459c.png";